var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B5D6ABA8-F67F-4F0F-A219-77D07BC4C5D8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Page---",
    transform: "translate(-21.000000, -109.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(-1.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo",
    transform: "translate(22.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.96,2 L13.96,13.44 C13.96,13.7272025 13.7272025,13.96 13.44,13.96 L2,13.96 C2,14.5343725 2.4656275,15 3.04,15 L13.44,15 C14.301575,15 15,14.301575 15,13.44 L15,3.04 C15,2.4656275 14.5343725,2 13.96,2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,11.5 L13,1.5 C13,0.6715625 12.3284375,0 11.5,0 L1.5,0 C0.6715625,0 0,0.6715625 0,1.5 L0,11.5 C0,12.3284375 0.6715625,13 1.5,13 L11.5,13 C12.3284375,13 13,12.3284375 13,11.5 Z M9.1479375,6.14209375 C9.14696875,6.1430625 9.14596875,6.14403125 9.145,6.145 L7,8.295 L4.855,6.15 C4.65996875,5.956125 4.34503125,5.956125 4.15,6.15 L1,9.295 L1,1.5 C1,1.22384375 1.22384375,1 1.5,1 L11.5,1 C11.7761562,1 12,1.22384375 12,1.5 L12,8.295 L9.855,6.15 C9.6619375,5.9525625 9.345375,5.94903125 9.1479375,6.14209375 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,3 C5.6715625,3 5,3.6715625 5,4.5 C5,5.3284375 5.6715625,6 6.5,6 C7.3284375,6 8,5.3284375 8,4.5 C8,3.6715625 7.3284375,3 6.5,3 Z M6.5,5 C6.22384375,5 6,4.77615625 6,4.5 C6,4.22384375 6.22384375,4 6.5,4 C6.77615625,4 7,4.22384375 7,4.5 C7,4.77615625 6.77615625,5 6.5,5 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.2368cdd566b8b511b904fa3a3802686f.svg";
export { ForwardRef as ReactComponent };